import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(window.scrollY > 300);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <div className="fixed bottom-28 right-6 z-50">
  {isVisible && (
    <button
      onClick={scrollToTop}
      className="flex items-center px-4 py-2 rounded-full bg-joyridePurple dark:bg-joyrideCyan text-joyrideCyan dark:text-joyrideNavy 
                 shadow-[0_8px_30px_rgba(0,0,0,0.5)] 
                 hover:shadow-[0_12px_40px_rgba(0,0,0,0.6)] 
                 transition-transform transform hover:scale-105"
      aria-label="Siirry sivun yläosaan"
    >
      <FaArrowUp className="mr-2" />
      alkuun!
    </button>
  )}
</div>

  );
};

export default ScrollToTop;
